(function($) {
	$(document).ready(function(){
		
		$(window).keyup(function (e) {
			var code = (e.keyCode ? e.keyCode : e.which);
			if (e.key === "Escape") { // escape key maps to keycode `27`
	            $('body').removeClass('keyboard-navigation');
	        } else {
	        	$('body').addClass('keyboard-navigation');
	        }

		});

		$(document).click(function() {
		  	$('body').removeClass('keyboard-navigation');
		});

	});


	$(window).on('load', function () {
        
        
	});
	
})(jQuery);